// extracted by mini-css-extract-plugin
export default {"wrapper":"StatisticClients_wrapper__o8w8k","total":"StatisticClients_total__ovrbP","totalRow":"StatisticClients_totalRow__gR8vH"};